module.exports = __webpack_public_path__ + "img/logo-lumo.14d0bc5b.png";